import React, { useEffect, useState } from 'react';
import StatsCard from '../StatsCard';
import {
  IconChartBar,
  IconPill,
  IconSearch,
  IconUserCheck,
} from '@tabler/icons-react';
import drugSearchAnalyticService from '../../../services/drug-search-analytics.service';

const DrugSearchStatsCards = ({ filters }) => {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setError(false);
      setLoading(true);
      try {
        const data = await drugSearchAnalyticService.getDrugSearchStats({
          ...filters,
        });
        setStatsData(data);
      } catch (err) {
        console.error('Error fetching stats:', err);
        setError('Failed to load statistics.');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [filters]);

  if (error) {
    return (
      <div className="col-span-full">
        <div className="text-center text-red-600">{error}</div>
      </div>
    );
  }

  const totalDrugSearches = statsData?.total_drug_searches;
  const uniqueDrugsSearched = statsData?.unique_drugs_looked_up;
  const averageSearchPerUser = statsData?.avg_searches_per_user;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <StatsCard
        title="Total Drug Searches"
        value={totalDrugSearches ?? '-'}
        icon={<IconSearch size={24} />}
        color="primary"
        loading={loading}
      />
      <StatsCard
        title="Unique Drugs Searched"
        value={uniqueDrugsSearched ?? '-'}
        icon={<IconPill size={24} />}
        color="success"
        loading={loading}
      />
      <StatsCard
        title="Avg Search per User"
        value={averageSearchPerUser ?? '-'}
        icon={<IconUserCheck size={24} />}
        color="info"
        loading={loading}
      />
    </div>
  );
};

export default DrugSearchStatsCards;
